import { getAction, listAction, createAction, deleteAction, updateAction } from "@/data/connection";
import { Image } from "@/components/blocks/image/image.class";
import { Project } from "../classes/project.class";

/**
 * Gets a center entry.
 */
export const getProjectEntry = function (value, slugOrId, recursive) {
	return getAction( "projects", value, slugOrId, recursive).then(data => {
		return processEntry(data.data[0]);
	});
}

/**
 * Gets a list of centers.
 */
export const getProjectsList = function (recursive, page, author, perPage) {
	return listAction("projects", recursive, page, author, perPage).then(data => {
		return { content: processList(data.data), totalEntries: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
	});
}

/**
 * Creates a list of Projects.
 */
export const createProjectEntry = function (body) {
	return createAction("projects", body).then(data => {
		return data;
	});
}

/**
 * Deletes a Project.
 */
export const deleteProjectEntry = function (id) {
	return deleteAction("projects", id).then(data => {
		return data;
	});
}

/**
 * Edits a Project.
 */
export const updateProjectEntry = function (id, body) {
	return updateAction("projects", id, body).then(data => {
		return data;
	});
}

/**
 * Process data.
 */
const processData = function(data) {
	let content = data.data;
	return content;
}

/**
 * Process Entry.
 */
const processEntry = function(data) {
	
	
	let content = new Project( data );

	return content;
}

/**
 * Process List.
 */
const processList = function(data) {
	let content = data;

	content = content.map(value => {
		return processEntry(value)
	})

	return content;
}



// WEBPACK FOOTER //
// ./src/data/models/project.model.js